/* eslint-disable react/jsx-no-duplicate-props */
'use client'

import React from 'react'
import { motion, useAnimationControls } from 'framer-motion'
import { LoaderCircle } from 'lucide-react'

const Loading = ({
    isLoading = true,
    onComplete = () => {},
  }: {
    isLoading?: boolean
    onComplete?: () => void
  }) => {
    const controls = useAnimationControls()
  
    React.useEffect(() => {
      if (isLoading) {
        controls.start({
          backgroundColor: [
            'rgba(17, 24, 39, 0.5)',
            'rgba(55, 65, 81, 0.5)',
            'rgba(31, 41, 55, 0.5)',
            'rgba(17, 24, 39, 0.5)',
          ],
          transition: { duration: 4, repeat: Infinity, ease: 'linear' }
        })
      }
    }, [isLoading, controls])
  
    if (!isLoading) return null
  
    return (
      <motion.div
        initial={{ opacity: 1 }}
        animate={controls}
        exit={{ opacity: 0 }}
        className="fixed inset-0 flex justify-center items-center z-30 backdrop-blur-sm"
      >
        <motion.div
          initial={{ scale: 0.5, rotate: 0 }}
          animate={{ 
            scale: [1, 1.2, 1],
            rotate: 360,
            backgroundColor: ['#2563eb', '#7c3aed', '#db2777', '#2563eb'],
          }}
          transition={{
            scale: { 
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
              times: [0, 0.5, 1]
            },
            rotate: { duration: 2, repeat: Infinity },
            backgroundColor: { duration: 4, repeat: Infinity, ease: "linear" }
          }}
          className="rounded-full p-4 shadow-lg"
        >
          <motion.div
            animate={{
              scale: [1, 1.2, 1],
              rotate: [0, 180, 360],
            }}
            transition={{
              duration: 2,
              ease: "easeInOut",
              times: [0, 0.5, 1],
              repeat: Infinity,
            }}
            onAnimationComplete={onComplete}
          >
            <LoaderCircle className="w-8 h-8 text-white" />
          </motion.div>
        </motion.div>
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="absolute bottom-10 left-0 right-0 text-center"
        >
          <motion.p
            animate={{
              color: ['#ffffff', '#e5e7eb', '#9ca3af', '#ffffff'],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "linear"
            }}
            className="text-xl font-semibold"
          >
            Loading...
          </motion.p>
        </motion.div>
      </motion.div>
    )
  }
  

// Optional loading container component for specific sections
export const Loader = ({
  isLoading= true
}: {
  isLoading?: boolean
}) => {
  return (
      isLoading ? (
        <div className="fixed inset-0 flex justify-center items-center z-30">
        <Loading isLoading={isLoading} />
      </div>
    ) : 
      null
      
  )
}

export default Loader